import { render } from "./form-eer-general-trust-money.html?vue&type=template&id=4483c4a6&scoped=true&ts=true&external"
import script from "./form-eer-general-trust-money.ts?vue&type=script&lang=ts&external"
export * from "./form-eer-general-trust-money.ts?vue&type=script&lang=ts&external"

import "./form-eer-general-trust-money.scss?vue&type=style&index=0&id=4483c4a6&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4483c4a6"]])

export default __exports__